var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,11.8l-3.4-1.9c-0.1-0.1-0.3,0-0.3,0.2v3.8c0,0.2,0.1,0.3,0.3,0.2l3.4-1.8C14.3,12.1,14.3,11.9,14.2,11.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.4,14c0,1.8-1.5,3.2-3.2,3.2H7.8 c-1.8,0-3.2-1.5-3.2-3.2v-4c0-1.8,1.5-3.2,3.2-3.2h8.4c1.8,0,3.2,1.5,3.2,3.2C19.4,10,19.4,14,19.4,14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.91c810fd9ca7d027e4696e6f53c330bb.svg";
export { ForwardRef as ReactComponent };